import { FormattedMessage } from 'react-intl';
import { NavItemType } from 'types/menu';
import {
    dashboardWorkflowsPath,
    workflowListPath,
    projectListPath,
    containerListPath,
    jobScriptsListPath,
    dashboardGeneralPath,
    dashboardTransferStatusStagePath,
    dashboardTransferStatusDeletePath,
    dashboardDdiPath,
    remoteFileManagerPath,
    datasetListPath,
    dashboardResourceUsagePath,
} from 'routes/paths';
import { REMOTE_FILE_MANAGEMENT_ALLOWED } from 'config';
import { TbLayoutDashboardFilled } from 'react-icons/tb';
import { AiOutlineGlobal } from 'react-icons/ai';
import { GoWorkflow, GoContainer } from 'react-icons/go';
import { FaCloudUploadAlt } from 'react-icons/fa';
import { SiStagetimer } from 'react-icons/si';
import { MdDelete, MdOutlinePublic, MdFolderOpen, MdDataUsage } from 'react-icons/md';
import { IoIosApps } from 'react-icons/io';
import { RiListSettingsLine } from 'react-icons/ri';
import { PiComputerTower } from 'react-icons/pi';
import { VscCircuitBoard } from 'react-icons/vsc';
import { GrDatabase } from 'react-icons/gr';
import { HiOutlineClipboardDocumentList } from 'react-icons/hi2';
import { InstanceType } from 'types/enums';

const icons = {
    AiOutlineGlobal,
    IoIosApps,
    GoWorkflow,
    GoContainer,
    RiListSettingsLine,
    PiComputerTower,
    MdOutlinePublic,
    FaCloudUploadAlt,
    TbLayoutDashboardFilled,
    SiStagetimer,
    MdDelete,
    VscCircuitBoard,
    GrDatabase,
    HiOutlineClipboardDocumentList,
    MdFolderOpen,
    MdDataUsage,
};

const menu: NavItemType = {
    id: 'menu',
    title: <FormattedMessage id='menu' />,
    type: 'group',

    children: [
        {
            id: 'dashboard',
            title: <FormattedMessage id='dashboard' />,
            type: 'collapse',
            icon: icons.TbLayoutDashboardFilled,

            children: [
                {
                    id: 'dashboard-general',
                    title: <FormattedMessage id='dashboard-general' />,
                    type: 'item',
                    url: dashboardGeneralPath(),
                    icon: icons.AiOutlineGlobal,
                    instanceAllowed: [InstanceType.LEXIS],
                    instanceDisallowed: [InstanceType.EFP],
                },
                {
                    id: 'dashboard-ddi',
                    title: <FormattedMessage id='dashboard-ddi' />,
                    type: 'item',
                    url: dashboardDdiPath(),
                    icon: icons.GrDatabase,
                },
                {
                    id: 'dashboard-workflows',
                    title: <FormattedMessage id='dashboard-workflows' />,
                    type: 'item',
                    url: dashboardWorkflowsPath(),
                    icon: icons.GoWorkflow,
                },
                {
                    id: 'dashboard-resource-usage',
                    title: <FormattedMessage id='dashboard-resource-usage' />,
                    type: 'item',
                    url: dashboardResourceUsagePath(),
                    icon: icons.MdDataUsage,
                    instanceAllowed: [InstanceType.LEXIS],
                    instanceDisallowed: [InstanceType.EFP],
                },
                {
                    id: 'dashboard-data-operations',
                    title: <FormattedMessage id='dashboard-data-operations' />,
                    type: 'collapse',
                    icon: icons.RiListSettingsLine,
                    children: [
                        {
                            id: 'dashboard-stage-transfer-statuses',
                            title: <FormattedMessage id='stage' />,
                            type: 'item',
                            url: dashboardTransferStatusStagePath(),
                            icon: icons.SiStagetimer,
                        },
                        {
                            id: 'dashboard-delete-transfer-statuses',
                            title: <FormattedMessage id='delete' />,
                            type: 'item',
                            url: dashboardTransferStatusDeletePath(),
                            icon: icons.MdDelete,
                        },
                    ],
                },
            ],
        },
        {
            id: 'data-management',
            title: <FormattedMessage id='dataManagement' />,
            type: 'collapse',
            icon: icons.GrDatabase,
            children: [
                {
                    id: 'data-sets',
                    title: <FormattedMessage id='data-sets' />,
                    type: 'item',
                    url: datasetListPath(),
                    icon: icons.FaCloudUploadAlt,
                },
                {
                    id: 'containers',
                    title: <FormattedMessage id='containers' />,
                    type: 'item',
                    url: containerListPath(),
                    icon: icons.GoContainer,
                },
                {
                    id: 'job-scripts',
                    title: <FormattedMessage id='job-scripts' />,
                    type: 'item',
                    url: jobScriptsListPath(),
                    icon: icons.VscCircuitBoard,
                },
            ],
        },

        ...(REMOTE_FILE_MANAGEMENT_ALLOWED
            ? [
                  {
                      id: 'remote-file-manager',
                      title: <FormattedMessage id='remote-file-manager' />,
                      type: 'item' as const,
                      url: remoteFileManagerPath(),
                      icon: icons.MdFolderOpen,
                  },
              ]
            : []),

        {
            id: 'workflows',
            title: <FormattedMessage id='workflows' />,
            type: 'item',
            url: workflowListPath(),
            icon: icons.GoWorkflow,
        },
        {
            id: 'projects',
            title: <FormattedMessage id='projects' />,
            type: 'item',
            url: projectListPath(),
            icon: icons.HiOutlineClipboardDocumentList,
        },
    ],
};

export default menu;
